export const CRYPTO_FORM_CRITERIA = {
  WALLET_ADDRESS_MIN_LENGTH: 26,
  WALLET_ADDRESS_MAX_LENGTH: 62
}
